import React, { createContext } from "react";

export const ModelModeContext = createContext<string>("1");
